import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import PulseLoader from 'react-spinners/PulseLoader';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import Alert from 'up-ops-web-shared-components/lib/components/alert';
import theme from 'up-ops-web-shared-components/lib/styles/theme';

import { FormSubmitButton } from 'styles/CommonStyles';
import { showUploadErrorState } from 'state/atoms/upload';
import {
  formSubmissionErrorState,
  showSubmitErrorState,
} from 'state/atoms/submit';
import { failedUploadNames } from 'state/selectors/upload';
import { FormIdentifier } from 'lib/constants';
import { trackEvent } from 'lib/tracking';

type FormSubmitProps = {
  formType: FormIdentifier;
};

const FormSubmit = ({ formType }: FormSubmitProps) => {
  const { t } = useTranslation();
  const { formState } = useFormContext();

  const isShowUploadError = useRecoilValue(showUploadErrorState);
  const failedUploadFiles = useRecoilValue(failedUploadNames);
  const setShowUploadError = useSetRecoilState(showUploadErrorState);

  const isShowSubmitError = useRecoilValue(showSubmitErrorState);
  const submitError = useRecoilValue(formSubmissionErrorState);
  const setShowSubmitError = useSetRecoilState(showSubmitErrorState);
  return (
    <>
      <FormSubmitButton
        disabled={formState.isSubmitting}
        inline
        onClick={() => {
          trackEvent('user', 'click', 'submit-form', { type: formType });
        }}
        primary
      >
        {formState.isSubmitting ? (
          <PulseLoader color={theme.colors.borderDefault} size={12} />
        ) : (
          t('common.submit')
        )}
      </FormSubmitButton>
      {isShowSubmitError && submitError && (
        <Alert error onClose={() => setShowSubmitError(false)}>
          {submitError}
        </Alert>
      )}
      {isShowUploadError && !!failedUploadFiles.length && (
        <Alert error onClose={() => setShowUploadError(false)}>
          <Trans i18nKey="errors.uploadsFailed">
            Could not upload the following files:
            <ul>
              {failedUploadFiles.map((fileName) => (
                <li key={fileName}>{fileName}</li>
              ))}
            </ul>
          </Trans>
        </Alert>
      )}
    </>
  );
};

export default FormSubmit;
